import { render, staticRenderFns } from "./InfoDisplayBox.vue?vue&type=template&id=91f02f32&scoped=true&"
import script from "./InfoDisplayBox.vue?vue&type=script&lang=ts&"
export * from "./InfoDisplayBox.vue?vue&type=script&lang=ts&"
import style0 from "./InfoDisplayBox.vue?vue&type=style&index=0&id=91f02f32&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f02f32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
